import { get } from 'lodash';
import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { showAuthenticationPopup, load } from '../../../actions/common';
import { firebaseSigninRedirect, firebaseSigninUsernameAndPassword } from '../../../actions/auth';
import { renderTextField } from '../../../assets/formComponent';
import { GG_SITE_KEY } from '../../../assets/constant';
import { validateEmail, validatePassword } from '../../../assets/util';
// import queryString from 'query-string';
// import { LoginButton } from 'react-facebook';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class LoginForm extends Component {

    constructor(props) {
        super(props);
        // this.state = { firebaseError: null };
        // this.fbLoginClick = this.fbLoginClick.bind(this);
        this.firebaseFbLogin = this.firebaseFbLogin.bind(this);
        this.firebaseGgLogin = this.firebaseGgLogin.bind(this);
        this.firebaseAppleLogin = this.firebaseAppleLogin.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.authenticated === false && nextProps.authenticated === true) {
            this.props.showAuthenticationPopup(false);
        }
        if (this.props.auth_error !== nextProps.auth_error) {
            window.scrollTo(0, 0);
            if (this.props.suspicious) {
                this.props.change('popupLoginForm', 'secret', '');
            }
            // if (nextProps.auth_error === 'SIGNUP_NEED') {
            //     const {fbResponse} = this.props;
            //     this.props.change('popupSignupForm', 'first_name', fbResponse.first_name);
            //     this.props.change('popupSignupForm', 'last_name', fbResponse.last_name);
            //     this.props.change('popupSignupForm', 'email', fbResponse.email);
            //     this.props.showSignup(true);
            // }
        }
    }

    onSubmit(values) {
        var error_obj = { _error: 'Login failed!' };
        var error = false;

        if (!values.email) {
            error_obj.email = "Email is required";
            error = true;
        } else if (!validateEmail(values.email)) {
            error_obj.email = "Email is invalid";
            error = true;
        }

        if (!values.password) {
            error_obj.password = "Password is required";
            error = true;
        } else if (!validatePassword(values.password)) {
            error_obj.password = "Password needs to be more than 8 characters.";
            error = true;
        }

        if (error) {
            throw new SubmissionError(error_obj);
        } else {
            return this.props.firebaseSigninUsernameAndPassword(values.email, values.password);
            // this.props.signin(values.email, values.password, values.keep, values.captchaResponse);
        }
    }

    firebaseFbLogin() {
        this.props.firebaseSigninRedirect("facebook");
    }

    firebaseGgLogin() {
        this.props.firebaseSigninRedirect("google");
    }

    firebaseAppleLogin() {
        this.props.firebaseSigninRedirect("apple");
    }

    renderCaptcha({ input }) {
        return (
            <div className="captcha col-xl-6 col-12 pa-2 pl-0">
                <ReCAPTCHA sitekey={GG_SITE_KEY} onChange={response => input.onChange(response)} />
            </div>
        )
    }

    render() {
        const { handleSubmit, translate, q } = this.props;
        const { auth_error, suspicious } = this.props;

        return (
            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                {(auth_error || Boolean(get(q, "error", null))) && <div className="err-alert form-group row px-0 mx-auto">
                    <div className="alert alert-danger col-12" role="alert">
                        {translate(`ERROR.AUTH.${get(auth_error, 'code', null)}`, auth_error.message, { showMissingTranslationMsg: auth_error.message }) || translate(`ERROR.${get(q, "error", "").toUpperCase()}`)}
                    </div>
                </div>}
                <Field component={renderTextField} label="Email" name="email" type="text" />
                <Field component={renderTextField} label="Password" name="password" type="password" />
                <div className="d-flex justify-content-between w-100">
                    <div></div>
                    {/* <label className="checkbox-container d-inline-block"><span className="text-decoration-none">Remember Me</span> */}
                    {/* <Field component={({input, label, type, meta: { touched, error, warning }}) => {return (<input type="checkbox" {...input} />)}} name="keep" /> */}
                    {/* <span className="checkmark"><FontAwesomeIcon icon={["fas", "square-full"]} /></span> */}
                    {/* </label> */}
                    <span onClick={this.props.onForgotClick} className="link forgot-password">ลืมรหัสผ่าน</span>
                </div>
                {suspicious && <Field name="captchaResponse" component={this.renderCaptcha} />}
                <button className="btn btn-black btn-login mt-3" type="submit">เข้าสู่ระบบ</button>
                <div className="text-center my-1">หรือ</div>
                <button className="btn btn-facebook mb-3" type="button" onClick={this.firebaseFbLogin} >เข้าสู่ระบบด้วย Facebook</button>
                <button className="btn btn-secondary mb-3" type="button" onClick={this.firebaseGgLogin} >เข้าสู่ระบบด้วย Google</button>
                <button className="btn btn-google" type="button" onClick={this.firebaseAppleLogin} >เข้าสู่ระบบด้วย Apple</button>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        auth_error: state.auth.error,
        suspicious: state.common.suspicious,
        translate: getTranslate(state.locale),
    }
}
export default reduxForm({
    form: 'popupLoginForm'
})(connect(mapStateToProps, { showAuthenticationPopup, load, firebaseSigninRedirect, firebaseSigninUsernameAndPassword })(LoginForm));